/** Minimal in-memory Storage used when sessionStorage is unavailable (SSR, privacy modes). */
export function createMemoryStorage(): Storage {
  const map = new Map<string, string>();
  return {
    get length() {
      return map.size;
    },
    clear: () => map.clear(),
    getItem: (key) => map.get(key) ?? null,
    key: (index) => Array.from(map.keys())[index] ?? null,
    removeItem: (key) => {
      map.delete(key);
    },
    setItem: (key, value) => {
      map.set(key, String(value));
    },
  };
}

/** Returns `window.sessionStorage` when accessible, else an in-memory fallback. */
export function resolveStorage(preferred?: Storage): Storage {
  if (preferred) return preferred;
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const probe = '__zagru_probe__';
      window.sessionStorage.setItem(probe, '1');
      window.sessionStorage.removeItem(probe);
      return window.sessionStorage;
    }
  } catch {
    // fall through
  }
  return createMemoryStorage();
}

/** Lists keys with a given prefix (Storage has no iteration API). */
export function keysWithPrefix(storage: Storage, prefix: string): string[] {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && key.startsWith(prefix)) keys.push(key);
  }
  return keys;
}
